import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {useTheme} from '@mui/material/styles';
import FlowFooter from './FlowFooter';

const CompleteDetailsLayout = ({children, isSubmitting, onBack, onSubmit}) => {
  const theme = useTheme();
  return <main className='complete-details' style={{
    '--complete-secondary': theme.palette.secondary.main,
    '--complete-primary': theme.palette.primary.main,
    '--complete-text-secondary': theme.palette.text.secondary,
    '--complete-action-selected': theme.palette.action.selected,
    '--complete-title-size': theme.typography.pxToRem(30),
    '--complete-body-size': theme.typography.pxToRem(15),
    '--complete-heading-size': theme.typography.pxToRem(19),
    '--complete-caption-size': theme.typography.pxToRem(12.5),
    '--complete-weight-bold': theme.typography.fontWeightBold,
    '--complete-weight-black': theme.typography.fontWeightBlack,
  }}>
    <div className='complete-details__heading'>
      <h1><FormattedMessage id='completeDetails.heading'/><span className='complete-details__dot' aria-hidden='true'/></h1>
      <p><FormattedMessage id='completeDetails.subtitle'/></p>
    </div>
    <div className='complete-details__cards'>{children}</div>
    <FlowFooter
      onBack={onBack}
      onNext={onSubmit}
      nextDisabled={isSubmitting}
      nextLoading={isSubmitting}
      nextLabel={<FormattedMessage id='continue'/>}
      primaryButtonProps={{'data-testid': 'complete-details-continue-purchase'}}
    />
  </main>;
};

CompleteDetailsLayout.propTypes = {
  children: PropTypes.node.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default CompleteDetailsLayout;